import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { HelpContactForm } from "../types/HelpSupportOption";
import { ROUTE } from "../routes";
import { useNavigate } from "react-router-dom";

const fetch = (authHeader: string) => () =>
  axios.get<HelpContactForm>(`${env.verifyServiceUrl}common/support_form/`, {
    headers: {
      Authorization: authHeader,
    },
  });
export const useSupportContactForm = () => {
  const { authHeader, isLoggedIn } = useAuth();
  const navigate = useNavigate();
  return useQuery(["helpContactForm"], fetch(authHeader), {
    enabled: isLoggedIn,
    retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
